import React from 'react';

const Logo = () => {
    return (
        <div className="logo-container">
            <a className="logo" href="#home-a">Startup</a>
        </div>
    )
}; 

export default Logo;